import { MODULE_CONFIG } from '../../config/subscriptionConfig';
import { Btn, Card, Grid, IconLock, IconShield, IconTrend } from '../ui';

const UPSELL_FEATURES = [
    {
        title: 'MSHA/OSHA training plans',
        body: 'Build multi-day plans with time targets and category coverage for compliance cycles.',
    },
    {
        title: '365-day schedule builder',
        body: 'Auto-schedule topics across the full plan cycle so the right lesson shows each day.',
    },
    {
        title: 'Per-user compliance tracking',
        body: 'See who’s on track, behind schedule, or at risk before an audit.',
    },
    {
        title: 'Master topic library',
        body: 'Manage a shared library of training topics with videos, PDFs, and posters.',
    },
    {
        title: 'Permanent training records',
        body: 'Keep audit-ready logs of who viewed what and when across your crew.',
    },
    {
        title: 'Affidavits & compliance reports',
        body: 'Generate one-click compliance affidavits and reporting for inspectors.',
    },
];

interface UpgradeUpsellCardProps {
    onUpgrade: () => void;
}

export function UpgradeUpsellCard({ onUpgrade }: UpgradeUpsellCardProps) {
    const training = MODULE_CONFIG.training;

    return (
        <Card variant="card-lg" cardClasses="db-upsell-card">
            <div className="db-upsell-header">
                <div className="db-upsell-icon" aria-hidden="true">
                    <IconShield iconClasses="db-upsell-shield" />
                </div>
                <div className="db-upsell-copy">
                    <h2>Need more than a daily briefing?</h2>
                    <p>
                        Upgrade to the full Safety &amp; Training module for compliance tracking,
                        scheduled training plans, and per-user records.
                    </p>
                </div>
            </div>

            <Grid gridColumns={3} gridClasses="db-upsell-grid">
                {UPSELL_FEATURES.map((feature) => (
                    <div key={feature.title} className="db-upsell-feature">
                        <IconLock iconClasses="db-upsell-lock" />
                        <h3>{feature.title}</h3>
                        <p>{feature.body}</p>
                    </div>
                ))}
            </Grid>

            <div className="db-upsell-footer">
                <span className="db-upsell-price">
                    {training.name} Add-On · {training.rateLabel} per company · Unlimited users
                </span>
                <Btn
                    variant="warning"
                    buttonText="Upgrade to Full Safety & Training"
                    buttonIcon={<IconTrend />}
                    buttonOnClick={onUpgrade}
                />
            </div>
        </Card>
    );
}
